import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

interface UseDeleteEstablishmentInfrastructureProps {
  id: string
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: ErrorResponse) => void
}

export const useDeleteEstablishmentInfrastructure = ({
  id,
  onSuccess,
  onError,
}: UseDeleteEstablishmentInfrastructureProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['deleteEstablishmentInfrastructure'],
    mutationFn: () => privateAxios.delete(`/maintenance/establishment_infrastructures/${id}`),
    onSuccess,
    onError,
  })
}
